import type { StoreSettings } from '../types';

export function shippingCostForCity(city: string, settings: StoreSettings) {
  const normalized = city.trim().toLowerCase();
  if (/القدس|ירושלים|jerusalem/.test(normalized)) return settings.shippingJerusalem;
  if (/الداخل|تل أبيب|تل ابيب|حيفا|يافا|الناصرة|عكا|الرملة|اللد|طيرة|תל אביב|חיפה|יפו|נצרת|עכו/.test(normalized)) return settings.shippingInside;
  return settings.shippingWestBank;
}

export function shippingAreaForCity(city: string, language: 'ar' | 'he') {
  const normalized = city.trim().toLowerCase();
  if (/القدس|ירושלים|jerusalem/.test(normalized)) return language === 'ar' ? 'القدس' : 'ירושלים';
  if (/الداخل|تل أبيب|تل ابيب|حيفا|يافا|الناصرة|عكا|الرملة|اللد|طيرة|תל אביב|חיפה|יפו|נצרת|עכו/.test(normalized)) return language === 'ar' ? 'الداخل' : 'השטחים הפנימיים';
  return language === 'ar' ? 'الضفة الغربية' : 'הגדה המערבית';
}


export type ShippingZone = 'west_bank' | 'jerusalem' | 'inside';

export function shippingCostForZone(zone: ShippingZone, settings: StoreSettings) {
  if (zone === 'jerusalem') return settings.shippingJerusalem;
  if (zone === 'inside') return settings.shippingInside;
  return settings.shippingWestBank;
}

export function shippingLabelForZone(zone: ShippingZone, language: 'ar' | 'he') {
  if (zone === 'jerusalem') return language === 'ar' ? 'القدس' : 'ירושלים';
  if (zone === 'inside') return language === 'ar' ? 'الداخل' : 'האזורים הפנימיים';
  return language === 'ar' ? 'الضفة الغربية' : 'הגדה המערבית';
}

export function shippingCityForZone(zone: ShippingZone, language: 'ar' | 'he') {
  if (zone === 'jerusalem') return language === 'ar' ? 'القدس' : 'ירושלים';
  if (zone === 'inside') return language === 'ar' ? 'الداخل' : 'פנים';
  return language === 'ar' ? 'الضفة الغربية' : 'הגדה המערבית';
}
